import {
  columnFacetingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
  useTable,
  type RowData,
} from "@tanstack/react-table";

/**
 * The one feature set every DataTable in the app is created with. TanStack
 * Table v9 makes features opt-in and threads them through every public type,
 * so the table-adjacent types below — and the props of every component that
 * receives a table, column or cell — are pinned to this set.
 *
 * columnFacetingFeature is registered without a faceted row model on purpose:
 * getFacetedUniqueValues() then returns a stable empty map, which is the
 * behaviour this app already had under v8 (facet count badges never rendered).
 */
export const appTableFeatures = tableFeatures({
  columnFacetingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
});

export type AppTableFeatures = typeof appTableFeatures;

/**
 * The table instance `useTable` hands back for this feature set — derived from
 * the hook itself so the props of components that receive a table cannot drift
 * from what `DataTable` actually creates.
 */
export type AppTable<TData extends RowData> = ReturnType<
  typeof useTable<AppTableFeatures, TData>
>;
